(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
      var range = slider.querySelector('[data-ba-range]');
      if (!range) return;
      var update = function () {
        slider.style.setProperty('--ba-pos', range.value + '%');
      };
      range.addEventListener('input', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hero-carousel]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (!slides.length) return;
    var index = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var show = function (next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    };
    show(0);
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    if (reduce) {
      root.querySelectorAll('video[data-hero-autoplay]').forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
      if (track.dataset.cloned) return;
      var list = track.querySelector('.logo-marquee__list');
      if (!list) return;
      var clone = list.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (el) {
        el.removeAttribute('id');
      });
      track.appendChild(clone);
      track.dataset.cloned = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pillow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Gallery ---------- */
    var root = document.querySelector('[data-pg]');
    if (root) {
      var viewport = root.querySelector('[data-pg-viewport]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pg-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pg-thumb]'));
      var track = root.querySelector('[data-pg-track]');
      var thumbsViewport = root.querySelector('[data-pg-thumbs-viewport]');
      var count = root.querySelector('[data-pg-count]');
      var lightbox = root.querySelector('[data-pg-lightbox]');
      var lightboxImg = root.querySelector('[data-pg-lightbox-img]');
      var current = 0;
      var total = slides.length;

      var positionThumbs = function () {
        if (!track || !thumbsViewport || !thumbs.length) return;
        var slot = thumbsViewport.clientWidth / 5;
        var maxFirst = Math.max(0, total - 4);
        var first = Math.min(Math.max(current - 1, 0), maxFirst);
        track.style.transform = 'translateX(' + -first * slot + 'px)';
      };

      var setActive = function (index) {
        current = index;
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
          if (i === index) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (count) count.textContent = index + 1 + ' / ' + total;
        positionThumbs();
      };

      var goTo = function (index) {
        if (!total) return;
        var next = (index + total) % total;
        viewport.scrollTo({ left: next * viewport.clientWidth, behavior: 'smooth' });
        setActive(next);
      };

      root.querySelectorAll('[data-pg-prev]').forEach(function (b) {
        b.addEventListener('click', function () {
          goTo(current - 1);
        });
      });
      root.querySelectorAll('[data-pg-next]').forEach(function (b) {
        b.addEventListener('click', function () {
          goTo(current + 1);
        });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-index'), 10));
        });
      });

      var scrollTimer;
      viewport.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
            if (index !== current) setActive(index);
          }, 60);
        },
        { passive: true }
      );

      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(current - 1);
        if (e.key === 'ArrowRight') goTo(current + 1);
      });

      var openZoom = function () {
        var slide = slides[current];
        var src = slide && slide.getAttribute('data-zoom');
        if (!src || !lightbox || typeof lightbox.showModal !== 'function') return;
        var img = slide.querySelector('img');
        lightboxImg.src = src;
        lightboxImg.alt = img ? img.alt : '';
        lightbox.showModal();
      };
      var zoomBtn = root.querySelector('[data-pg-zoom]');
      if (zoomBtn) zoomBtn.addEventListener('click', openZoom);
      viewport.addEventListener('click', function (e) {
        if (e.target.closest('.pg__img')) openZoom();
      });
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox || e.target === lightboxImg || e.target.closest('[data-pg-lightbox-close]')) lightbox.close();
        });
      }

      window.addEventListener('resize', function () {
        viewport.scrollLeft = current * viewport.clientWidth;
        positionThumbs();
      });
      setActive(0);
    }

    /* ---------- Pack cards ---------- */
    var packs = document.querySelector('[data-pp-packs]');
    if (packs) {
      var apply = function (input) {
        packs.querySelectorAll('.pp-pack').forEach(function (card) {
          card.classList.toggle('is-selected', card.contains(input));
        });
        document.querySelectorAll('.product-main--pillow .buy-form [data-variant-input]').forEach(function (field) {
          field.value = input.value;
        });
        var now = document.querySelector('[data-pp-now]');
        if (now) now.textContent = input.getAttribute('data-price');
        var was = document.querySelector('[data-pp-was]');
        if (was) {
          var compare = input.getAttribute('data-compare');
          was.textContent = compare;
          was.hidden = !compare;
        }
        var save = document.querySelector('[data-pp-save]');
        if (save) {
          var off = parseInt(input.getAttribute('data-off'), 10) || 0;
          save.textContent = off + '% OFF';
          save.hidden = off < 5;
        }
        document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
          el.textContent = input.getAttribute('data-price');
        });
        var swatchName = document.querySelector('[data-pp-swatch-name]');
        if (swatchName && input.getAttribute('data-name')) swatchName.textContent = input.getAttribute('data-name');
        if (input.getAttribute('data-name')) {
          document.querySelectorAll('.product-main--pillow [data-selected-colour]').forEach(function (el) {
            el.textContent = input.getAttribute('data-name');
          });
        }
        var mediaIndex = input.getAttribute('data-media-index');
        if (mediaIndex !== null && mediaIndex !== '' && apply.ready) {
          var thumb = document.querySelector('.product-main--pillow [data-pg-thumb][data-index="' + mediaIndex + '"]');
          if (thumb) thumb.click();
        }
      };
      packs.addEventListener('change', function (e) {
        if (e.target.matches('.pp-pack__input')) apply(e.target);
      });
      /* Kit cards: "Upgrade to …" button selects the pack it points to. */
      packs.addEventListener('click', function (e) {
        var up = e.target.closest('[data-pp-upgrade]');
        if (!up) return;
        e.preventDefault();
        e.stopPropagation();
        var target = packs.querySelector('.pp-pack__input[value="' + up.getAttribute('data-pp-upgrade') + '"]');
        if (target && !target.disabled) {
          target.checked = true;
          apply(target);
        }
      });
      var checked = packs.querySelector('.pp-pack__input:checked');
      if (checked) apply(checked);
      apply.ready = true;
    }

    /* ---------- Sticky add to basket (mobile) ---------- */
    var bar = document.querySelector('[data-pp-sticky]');
    var mainButton = document.querySelector('.product-main--pillow .buy-form button[name="add"]');
    if (bar && mainButton) {
      bar.hidden = false;
      var addBtn = bar.querySelector('[data-pp-sticky-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          mainButton.click();
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            });
          },
          { threshold: 0 }
        ).observe(mainButton);
      } else {
        bar.classList.add('is-visible');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-gallery]');
    if (!root) return;
    const scroller = root.querySelector('[data-gallery-scroller]');
    if (!scroller) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const slides = root.querySelectorAll('.gallery__slide');
    const thumbs = root.querySelectorAll('[data-gallery-thumb]');
    const thumbsScroller = root.querySelector('[data-thumbs-scroller]');
    const thumbsPrev = root.querySelector('[data-thumbs-prev]');
    const thumbsNext = root.querySelector('[data-thumbs-next]');
    const galleryPrev = root.querySelector('[data-gallery-prev]');
    const galleryNext = root.querySelector('[data-gallery-next]');
    const galleryZoom = root.querySelector('[data-gallery-zoom]');
    const lightbox = root.querySelector('[data-gallery-lightbox]');
    const lightboxImg = root.querySelector('[data-lightbox-image]');
    const lightboxClose = root.querySelector('[data-lightbox-close]');
    const lightboxPrev = root.querySelector('[data-lightbox-prev]');
    const lightboxNext = root.querySelector('[data-lightbox-next]');
    let currentIndex = 0;

    const scrollEl = (el, left, instant) => {
      if (!el) return;
      const x = Math.max(0, left);
      const behavior = reduce || instant ? 'auto' : 'smooth';
      if (typeof el.scrollTo === 'function') {
        el.scrollTo({ left: x, behavior: behavior });
      }
      if (instant || reduce) el.scrollLeft = x;
    };

    const slideLeft = (slide) => {
      if (!slide) return 0;
      return slide.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
    };

    const updateThumbArrows = () => {
      if (!thumbsScroller) return;
      const max = Math.max(0, thumbsScroller.scrollWidth - thumbsScroller.clientWidth);
      if (thumbsPrev) thumbsPrev.disabled = thumbsScroller.scrollLeft <= 2;
      if (thumbsNext) thumbsNext.disabled = thumbsScroller.scrollLeft >= max - 2;
    };

    const revealThumb = (id) => {
      if (!thumbsScroller || !id) return;
      const thumb = root.querySelector('[data-gallery-thumb][data-media-id="' + id + '"]');
      if (!thumb) return;
      const left = thumb.offsetLeft - (thumbsScroller.clientWidth - thumb.offsetWidth) / 2;
      scrollEl(thumbsScroller, Math.max(0, left));
    };

    const goToIndex = (index) => {
      if (!slides.length) return;
      const nextIndex = (index + slides.length) % slides.length;
      const slide = slides[nextIndex];
      scrollEl(scroller, slideLeft(slide));
      setCurrent(slide.getAttribute('data-media-id'));
    };

    const goTo = (id) => {
      const slide = scroller.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      scrollEl(scroller, slideLeft(slide), true);
      revealThumb(id);
    };

    const setCurrent = (id) => {
      thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', thumb.getAttribute('data-media-id') === id ? 'true' : 'false');
      });
      slides.forEach((slide, index) => {
        if (slide.getAttribute('data-media-id') === id) currentIndex = index;
      });
      revealThumb(id);
    };

    const mediaForColor = (value) => {
      const color = (value || '').toLowerCase();
      if (color === 'gold') return root.getAttribute('data-color-gold');
      if (color === 'black') return root.getAttribute('data-color-black');
      return '';
    };

    const showLightboxImage = (index) => {
      if (!lightboxImg || !slides.length) return;
      const slide = slides[(index + slides.length) % slides.length];
      const src = slide.getAttribute('data-zoom-src');
      if (!src) return false;
      lightboxImg.src = src;
      lightboxImg.alt = slide.getAttribute('data-zoom-alt') || '';
      return true;
    };

    const openLightbox = () => {
      if (!lightbox || typeof lightbox.showModal !== 'function') return;
      if (!showLightboxImage(currentIndex)) return;
      if (!lightbox.open) lightbox.showModal();
    };

    const closeLightbox = () => {
      if (lightbox && lightbox.open) lightbox.close();
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(thumb.getAttribute('data-media-id')));
    });
    if (galleryPrev) {
      galleryPrev.addEventListener('click', (event) => {
        event.stopPropagation();
        goToIndex(currentIndex - 1);
      });
    }
    if (galleryNext) {
      galleryNext.addEventListener('click', (event) => {
        event.stopPropagation();
        goToIndex(currentIndex + 1);
      });
    }
    if (galleryZoom) {
      galleryZoom.addEventListener('click', (event) => {
        event.stopPropagation();
        openLightbox();
      });
    }
    if (thumbsPrev) {
      thumbsPrev.addEventListener('click', () => {
        if (!thumbsScroller) return;
        scrollEl(thumbsScroller, thumbsScroller.scrollLeft - thumbsScroller.clientWidth * 0.8);
      });
    }
    if (thumbsNext) {
      thumbsNext.addEventListener('click', () => {
        if (!thumbsScroller) return;
        scrollEl(thumbsScroller, thumbsScroller.scrollLeft + thumbsScroller.clientWidth * 0.8);
      });
    }
    if (thumbsScroller) {
      thumbsScroller.addEventListener('scroll', updateThumbArrows, { passive: true });
      window.addEventListener('resize', updateThumbArrows);
    }

    scroller.addEventListener('click', (event) => {
      if (!event.target.closest('.gallery__img')) return;
      openLightbox();
    });
    scroller.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openLightbox();
    });

    if (lightbox) {
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox || event.target === lightboxImg) closeLightbox();
      });
    }
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (event) => {
        event.stopPropagation();
        goToIndex(currentIndex - 1);
        showLightboxImage(currentIndex);
      });
    }
    if (lightboxNext) {
      lightboxNext.addEventListener('click', (event) => {
        event.stopPropagation();
        goToIndex(currentIndex + 1);
        showLightboxImage(currentIndex);
      });
    }

    document.querySelectorAll('[data-option-name="Color"], [data-option-name="Colour"]').forEach((group) => {
      group.addEventListener('change', (event) => {
        const value = event.target.value;
        document.querySelectorAll('[data-selected-colour]').forEach((el) => {
          if (value) el.textContent = value;
        });
        const id = mediaForColor(value);
        if (!id) return;
        goTo(id);
        setCurrent(id);
      });
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const id = entry.target.getAttribute('data-media-id');
            if (id) setCurrent(id);
          });
        },
        { root: scroller, threshold: 0.55 }
      );
      slides.forEach((slide) => io.observe(slide));
    }

    const initial = root.getAttribute('data-initial-media');
    if (initial) {
      const slide = scroller.querySelector('[data-media-id="' + initial + '"]');
      if (slide) {
        scrollEl(scroller, slideLeft(slide), true);
        setCurrent(initial);
      }
    }

    const syncStickyOffset = () => {
      const header = document.querySelector('.site-header');
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      if (!desktop || !header) {
        root.style.top = '';
        root.style.maxHeight = '';
        return;
      }
      const offset = Math.ceil(header.getBoundingClientRect().height) + 16;
      root.style.top = offset + 'px';
      root.style.maxHeight = 'calc(100vh - ' + (offset + 8) + 'px)';
    };
    syncStickyOffset();
    window.addEventListener('resize', syncStickyOffset);
    updateThumbArrows();
  })();

  (function () {
    var link = document.querySelector('[data-reviews-jump]');
    if (!link) return;
    var target =
      document.getElementById('reviews') ||
      document.querySelector('.jdgm-reviews-grid-widget') ||
      document.querySelector('.jdgm-rev-widg');
    if (!target) return;
    if (!target.id) target.id = 'reviews';
    target.style.scrollMarginTop = '96px';
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var header = document.querySelector('.site-header');
      var offset = header ? Math.ceil(header.getBoundingClientRect().height) + 12 : 12;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.getElementById('reviews');
    if (!root) return;

    const fillSummary = function () {
      const summary = root.querySelector('[data-review-summary]');
      if (!summary) return;
      const cards = Array.from(root.querySelectorAll('[data-review-item]'));
      if (!cards.length) {
        summary.hidden = true;
        return;
      }
      let sum = 0;
      cards.forEach(function (card) {
        const star = Math.min(5, Math.max(1, parseInt(card.getAttribute('data-rating'), 10) || 5));
        sum += star;
      });
      const total = cards.length;
      const average = Math.round((sum / total) * 10) / 10;
      const starPath = 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';
      let stars = '';
      for (let i = 1; i <= 5; i += 1) {
        let cls = 'rating__star rating__star--off';
        if (average >= i) cls = 'rating__star rating__star--on';
        else if (average >= i - 0.5) cls = 'rating__star rating__star--half';
        stars +=
          '<svg class="' +
          cls +
          '" viewBox="0 0 24 24" focusable="false"><path class="rating__star-shape rating__star-shape--off" d="' +
          starPath +
          '"></path><path class="rating__star-shape rating__star-shape--on" d="' +
          starPath +
          '"></path></svg>';
      }
      summary.hidden = false;
      summary.innerHTML =
        '<span class="rating" role="img" aria-label="' +
        average +
        ' out of 5 stars from ' +
        total +
        ' reviews"><span class="rating__stars" aria-hidden="true">' +
        stars +
        '</span><span class="rating__value">' +
        average +
        '</span><span class="rating__count">' +
        total +
        (total === 1 ? ' review' : ' reviews') +
        '</span></span>';
    };
    fillSummary();

    const formDialog = root.querySelector('[data-review-form-dialog]');
    const writeBtn = root.querySelector('[data-review-write]');
    const formClose = root.querySelector('[data-review-form-close]');
    if (writeBtn && formDialog) {
      writeBtn.addEventListener('click', () => formDialog.showModal());
    }
    if (formClose && formDialog) {
      formClose.addEventListener('click', () => formDialog.close());
    }

    root.querySelectorAll('[data-review-text]').forEach((clip) => {
      const more = clip.parentElement.querySelector('[data-review-more]');
      if (!more) return;
      if (clip.scrollHeight > clip.clientHeight + 2) {
        more.hidden = false;
        more.addEventListener('click', () => {
          clip.classList.add('is-open');
          more.hidden = true;
        });
      }
    });

    root.querySelectorAll('[data-review-filter]').forEach((control) => {
      control.addEventListener('click', () => {
        const value = control.getAttribute('data-review-filter');
        root.querySelectorAll('[data-review-item]').forEach((item) => {
          item.hidden = value !== 'all' && item.getAttribute('data-rating') !== value;
        });
      });
    });

    const photos = root.querySelector('[data-review-photos]');
    const track = root.querySelector('[data-photos-track]');
    if (photos && track) {
      const slides = track.querySelectorAll('[data-photo-slide]');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const go = (index) => {
        const slide = slides[index];
        if (!slide) return;
        slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      };
      root.querySelectorAll('[data-review-photo]').forEach((btn, index) => {
        btn.addEventListener('click', () => {
          photos.showModal();
          go(index);
        });
      });
      const closePhotos = root.querySelector('[data-photos-close]');
      if (closePhotos) closePhotos.addEventListener('click', () => photos.close());
      const prev = root.querySelector('[data-photos-prev]');
      const next = root.querySelector('[data-photos-next]');
      let current = 0;
      if (prev) {
        prev.addEventListener('click', () => {
          current = (current - 1 + slides.length) % slides.length;
          go(current);
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          current = (current + 1) % slides.length;
          go(current);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-zones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var init = function (section) {
      if (section.dataset.zonesReady) return;
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-zone-panel]'));
      if (!panels.length) return;
      section.dataset.zonesReady = '1';

      var figure = section.querySelector('[data-zones-figure]');
      var glow = section.querySelector('[data-zones-glow]');
      var tabsEl = section.querySelector('[data-zones-tabs]');
      var dotsEl = section.querySelector('[data-zones-dots]');
      var uid = 'zones-' + Math.random().toString(36).slice(2, 8);
      var current = 0;
      var tabs = [];
      var spots = [];
      var dots = [];

      panels.forEach(function (panel, i) {
        var title = panel.getAttribute('data-zone-title') || 'Zone ' + (i + 1);
        panel.id = uid + '-panel-' + i;
        panel.setAttribute('aria-labelledby', uid + '-tab-' + i);

        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'support-zones__tab';
        tab.id = uid + '-tab-' + i;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.setAttribute('aria-label', (i + 1) + ': ' + title);
        tab.textContent = i + 1;
        tabsEl.appendChild(tab);
        tabs.push(tab);

        var spot = document.createElement('button');
        spot.type = 'button';
        spot.className = 'support-zones__spot';
        spot.setAttribute('aria-label', 'Show ' + title);
        spot.setAttribute('aria-controls', panel.id);
        spot.textContent = i + 1;
        spot.style.left = (panel.getAttribute('data-zone-x') || 50) + '%';
        spot.style.top = (panel.getAttribute('data-zone-y') || 50) + '%';
        figure.appendChild(spot);
        spots.push(spot);

        var dot = document.createElement('span');
        dotsEl.appendChild(dot);
        dots.push(dot);
      });

      var show = function (index) {
        current = (index + panels.length) % panels.length;
        panels.forEach(function (panel, i) {
          var on = i === current;
          panel.classList.toggle('is-active', on);
          panel.setAttribute('aria-hidden', on ? 'false' : 'true');
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[i].tabIndex = on ? 0 : -1;
          spots[i].setAttribute('aria-pressed', on ? 'true' : 'false');
          dots[i].classList.toggle('is-active', on);
        });
        if (glow) {
          glow.style.left = spots[current].style.left;
          glow.style.top = spots[current].style.top;
          glow.classList.add('is-on');
        }
      };

      /* Optional auto-advance: only while on screen, and it stops for good once someone taps. */
      var seconds = parseFloat(section.getAttribute('data-autoplay')) || 0;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      var stopped = !seconds || reduce || (window.Shopify && window.Shopify.designMode);
      var stop = function () {
        stopped = true;
        clearInterval(timer);
      };
      var run = function (visible) {
        clearInterval(timer);
        if (stopped || !visible) return;
        timer = setInterval(function () {
          show(current + 1);
        }, seconds * 1000);
      };

      var pick = function (i) {
        stop();
        show(i);
      };

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          pick(i);
        });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = current + 1;
          if (e.key === 'ArrowLeft') next = current - 1;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = panels.length - 1;
          if (next === null) return;
          e.preventDefault();
          pick(next);
          tabs[current].focus();
        });
      });
      spots.forEach(function (spot, i) {
        spot.addEventListener('click', function () {
          pick(i);
        });
      });

      /* Swipe the text panel on phones. */
      var panelsEl = section.querySelector('[data-zones-panels]');
      var startX = null;
      panelsEl.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      panelsEl.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) pick(current + (dx < 0 ? 1 : -1));
      });

      section.classList.add('is-ready');
      show(0);

      if (!stopped && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          run(entries[0].isIntersecting);
        }, { threshold: 0.4 }).observe(section);
      }

      /* Theme editor: jump to a zone when its block is selected. */
      section.addEventListener('shopify:block:select', function (e) {
        var i = panels.indexOf(e.target.closest('[data-zone-panel]') || e.target);
        if (i > -1) pick(i);
      });
    };

    var boot = function () {
      document.querySelectorAll('[data-zones]').forEach(init);
    };
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Videos load nothing until they are near the screen, and only play when tapped. */
    var videos = Array.prototype.slice.call(document.querySelectorAll('[data-ugc-video]'));
    if (!videos.length) return;

    var attach = function (video) {
      if (video.dataset.attached) return;
      video.dataset.attached = '1';
      video.querySelectorAll('source[data-src]').forEach(function (s) {
        s.src = s.getAttribute('data-src');
      });
      video.preload = 'metadata';
      video.load();
    };

    var frameOf = function (video) {
      return video.closest('.ugc-videos__frame');
    };

    var pause = function (video) {
      if (!video.paused) video.pause();
    };

    var flashTimer;
    var flash = function (frame) {
      frame.classList.add('is-flash');
      clearTimeout(flashTimer);
      flashTimer = setTimeout(function () {
        frame.classList.remove('is-flash');
      }, 700);
    };

    videos.forEach(function (video) {
      var frame = frameOf(video);
      var toggle = frame.querySelector('[data-ugc-toggle]');
      var sound = frame.querySelector('[data-ugc-sound]');

      video.addEventListener('play', function () {
        frame.classList.add('is-started', 'is-playing');
        frame.classList.remove('is-loading');
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^Play/, 'Pause'));
        if (sound) sound.hidden = false;
        videos.forEach(function (other) {
          if (other !== video) pause(other);
        });
      });
      video.addEventListener('pause', function () {
        frame.classList.remove('is-playing', 'is-loading');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^Pause/, 'Play'));
      });
      video.addEventListener('waiting', function () {
        if (video.paused) frame.classList.add('is-loading');
      });

      toggle.addEventListener('click', function () {
        attach(video);
        if (video.paused) {
          frame.classList.add('is-loading');
          video.play().catch(function () {
            frame.classList.remove('is-loading');
          });
        } else {
          video.pause();
        }
        flash(frame);
      });

      if (sound) {
        sound.addEventListener('click', function () {
          video.muted = !video.muted;
          sound.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
          sound.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        });
      }
    });

    if (!('IntersectionObserver' in window)) return;

    /* Fetch metadata shortly before a video scrolls into view. */
    var near = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            attach(entry.target);
            near.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    /* Pause a playing video once it is scrolled away. */
    var away = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) pause(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    videos.forEach(function (video) {
      near.observe(video);
      away.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var boot = function () {
      var root = document.querySelector('[data-wishlist-page]');
      if (!root) return;
      var list = root.querySelector('[data-wishlist-list]');
      var empty = root.querySelector('[data-wishlist-empty]');
      var catalog = [];
      try {
        var catalogEl = root.querySelector('[data-wishlist-catalog]');
        catalog = JSON.parse(catalogEl.textContent || '[]');
      } catch (e) {
        catalog = [];
      }

      var findCatalog = function (id) {
        var sid = String(id);
        for (var i = 0; i < catalog.length; i++) {
          if (String(catalog[i].id) === sid) return catalog[i];
        }
        return null;
      };

      var escapeHtml = function (value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };

      var render = function () {
        var store = window.powWishlist;
        var items = store && store.read ? store.read() : [];
        list.innerHTML = '';
        if (!items.length) {
          empty.hidden = false;
          list.hidden = true;
          return;
        }
        empty.hidden = true;
        list.hidden = false;
        items.forEach(function (item) {
          var extra = findCatalog(item.id) || {};
          var title = item.title || extra.title || 'Saved product';
          var url = item.url || extra.url || '/';
          var image = item.image || extra.image || '';
          var price = item.price || extra.price || '';
          var variantId = item.variantId || extra.variantId || '';
          var li = document.createElement('li');
          li.className = 'wishlist-page__card';
          li.innerHTML =
            (image
              ? '<img class="wishlist-page__img" src="' +
                escapeHtml(image) +
                '" alt="" width="96" height="96">'
              : '<span class="wishlist-page__img wishlist-page__img--empty" aria-hidden="true"></span>') +
            '<div class="wishlist-page__copy">' +
            '<a class="wishlist-page__title" href="' +
            escapeHtml(url) +
            '">' +
            escapeHtml(title) +
            '</a>' +
            (price ? '<p class="wishlist-page__price">' + escapeHtml(price) + '</p>' : '') +
            '<div class="wishlist-page__actions">' +
            (variantId
              ? '<form data-ajax-cart method="post" action="/cart/add">' +
                '<input type="hidden" name="id" value="' +
                escapeHtml(variantId) +
                '">' +
                '<input type="hidden" name="quantity" value="1">' +
                '<button class="btn btn--primary" type="submit">add to basket</button>' +
                '</form>'
              : '') +
            '<button class="btn btn--secondary" type="button" data-wishlist-remove data-product-id="' +
            escapeHtml(item.id) +
            '">Remove</button>' +
            '</div></div>';
          list.appendChild(li);
        });
      };

      root.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-wishlist-remove]');
        if (!btn || !window.powWishlist) return;
        event.preventDefault();
        window.powWishlist.remove(btn.getAttribute('data-product-id'));
      });

      document.addEventListener('wishlist:change', render);
      document.addEventListener('wishlist:ready', render);
      if (window.powWishlist) render();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
